"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextSkeleton = exports.Root = exports.RadioSkeleton = exports.PickupPointCardSkeleton = exports.Inner = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _models = require("../../../../models");
var _jsxRuntime = require("react/jsx-runtime");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(3),
  paddingTop: theme.spacing(3),
  '&:not(:last-child)': {
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
    paddingBottom: theme.spacing(3)
  }
}));
const Inner = exports.Inner = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1)
}));
const TextSkeleton = exports.TextSkeleton = (0, _mui.styled)(_mui.Skeleton)(({
  theme
}) => ({
  borderRadius: theme.spacing(1)
}));
const RadioSkeleton = exports.RadioSkeleton = (0, _mui.styled)(_mui.Skeleton)(({
  theme
}) => ({
  marginTop: theme.spacing(6.4)
}));
const PickupPointCardSkeleton = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Root, {
    "data-testid": getTestId(_models.TestId.PickupPointCardSkeleton),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(RadioSkeleton, {
      animation: "pulse",
      variant: "circular",
      height: 20,
      width: 20
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(Inner, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(TextSkeleton, {
        animation: "pulse",
        variant: "rectangular",
        height: 26,
        width: 53
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(TextSkeleton, {
        animation: "pulse",
        variant: "rectangular",
        height: 20,
        width: 169
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(TextSkeleton, {
        animation: "pulse",
        variant: "rectangular",
        height: 20,
        width: 169
      })]
    })]
  });
};
exports.PickupPointCardSkeleton = PickupPointCardSkeleton;